function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Logo Loota text");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Logo-/-Loota-text",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("text", {
  id: "Loota",
  fontFamily: "Montserrat-Bold, Montserrat",
  fontSize: 24,
  fontWeight: "bold",
  letterSpacing: 8,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 64,
  y: 34,
  fontFamily: "Avenir-Black"
}, "LOOTA")), /*#__PURE__*/React.createElement("g", {
  id: "Logo-/-Loota-solo",
  transform: "translate(-0.000000, 0.000000)",
  fill: "#00FFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.1485543,29.1327436 C27.2210568,29.1327436 26.3097817,29.2179621 25.4168449,29.3672705 C22.8953212,37.7454433 17.0115309,43.9537144 15.5557477,45.3960898 C18.9074345,47.7850241 23.3156927,50 28.1485543,50 C38.6402088,50 47.1428571,39.5667239 47.1428571,39.5667239 C47.1428571,39.5667239 38.6402088,29.1327436 28.1485543,29.1327436 M13.3057727,0 C13.3057727,0 23.7544026,9.7698397 23.7544026,21.8257881 C23.7551079,33.8782151 13.3057727,43.6508719 13.3057727,43.6508719 C13.3057727,43.6508719 2.85714286,33.8782151 2.85714286,21.8257881 C2.85714286,9.7698397 13.3057727,0 13.3057727,0",
  id: "Fill-1"
})));

var SvgLootaText = function SvgLootaText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "50px",
    viewBox: "0 0 190 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLootaText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Loota_text.11b5d650.svg";
export { ForwardRef as ReactComponent };